import { memo } from 'react';

import { ChevronDownIcon, ChevronUpIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { PDFCurrentPageInput } from '~/components/AssetModalV2/Visualizer/PDFVisualizer/PDFControls/components/PDFCurrentPageInput';

type PDFPageControlsProps = {
  currentPage: number;
  totalPages: number;
  goToPage: (pageNumber: number) => void;
  onFocusChange: (isFocused: boolean) => void;
};

export const PDFPageControls = memo(({ currentPage, totalPages, goToPage, onFocusChange }: PDFPageControlsProps) => {
  if (!currentPage || !totalPages) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-1">
      <IconButton
        adsIcon
        appearance="ghost"
        className="disabled:bg-transparent ads:disabled:text-icon-subtle disabled:text-gray-8"
        color="gray"
        disabled={currentPage === 1}
        icon={ChevronUpIcon}
        label="Page up"
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onClick={() => goToPage(currentPage - 1)}
        size="small"
      />

      <div className="flex items-center whitespace-nowrap font-semibold ads:text-primary text-12 text-gray-12">
        <PDFCurrentPageInput
          onFocusChange={onFocusChange}
          currentPage={currentPage}
          onGoToPage={goToPage}
          totalPages={totalPages}
        />
        <span>{` / ${totalPages}`}</span>
      </div>

      <IconButton
        adsIcon
        appearance="ghost"
        className="disabled:bg-transparent ads:disabled:text-icon-subtle disabled:text-gray-8"
        color="gray"
        disabled={currentPage === totalPages}
        icon={ChevronDownIcon}
        label="Page down"
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onClick={() => goToPage(currentPage + 1)}
        size="small"
      />
    </div>
  );
});

PDFPageControls.displayName = 'PDFPageControls';
